import { FC } from "react";
import { TextSwitch } from "react-migration/components/TextSwitch";

import { useTranslation } from "react-migration/lib/i18n/useTranslation";
import { PriceTypes } from "../../../typings/PriceTypes";
import { MeasurementSystem } from "src/js/stores/user/store";

export interface PriceTypeProps {
  priceType: PriceTypes;
  setPriceType: (priceType: PriceTypes) => void;
  unitPreference: MeasurementSystem;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  eventTracking?: (values: { filterName: string; filterState: any }) => void;
}

export const PriceType: FC<PriceTypeProps> = ({ priceType, setPriceType, unitPreference, eventTracking }) => {
  const { t } = useTranslation();

  return (
    <div className="flex gap-2 justify-between" data-testid="price-type">
      <h4 className="text-sm font-medium my-auto">{t("comparables.map.sidebar.filters.type.map.title")}</h4>
      <TextSwitch name="priceType" value={priceType} className="w-[200px]">
        <TextSwitch.Label
          value={PriceTypes.PER_AREA}
          onToggle={(ev) => {
            eventTracking?.({ filterName: "priceType", filterState: ev });
            setPriceType(ev);
          }}
        >
          {t("comparables.map.sidebar.filters.type.map.per_area", {
            currency: t("units.currency.default_currency"),
            areaType: t(
              unitPreference === MeasurementSystem.METRIC
                ? "comparables.map.sidebar.filters.mode.price.sqm.alt"
                : "comparables.map.sidebar.filters.mode.price.sqft.alt"
            ),
          })}
        </TextSwitch.Label>
        <TextSwitch.Label
          value={PriceTypes.PER_UNIT}
          onToggle={(ev) => {
            eventTracking?.({ filterName: "priceType", filterState: ev });
            setPriceType(ev);
          }}
        >
          {t("comparables.map.sidebar.filters.type.map.per_unit")}
        </TextSwitch.Label>
      </TextSwitch>
    </div>
  );
};
